import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url_img, site_url, invoice_img } from "./../config.js";
import { Link } from 'react-router-dom';
import { IndianCurrencyFormatter, FormatDate } from '../Function';
import { ConnectivityContext } from '../context/ConnectivityContext';
import { cachedGet } from '../services/apiCacheService';

function Index() {
  const { user } = useContext(AuthContext);
  const { effectiveMode } = useContext(ConnectivityContext);
  const [data, setdata] = useState([]);
  const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
  const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
  const [searchText, setSearchText] = useState('');



  const shopdetails = async () => {
   
  
    try {
      const responseData = await cachedGet(
        `${site_url}/billorderlist/${user.id}/${(fromDate ? fromDate : 'all')}/${(toDate ? toDate : 'all')}`,
        {},
        effectiveMode === 'offline'
      );
      const response = { data: responseData };
  
      if (response.data.status === 'success') {
        setdata(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching bill data", error);
    }
  };
  
  useEffect(() => {
    shopdetails();
  }, [user])
  useEffect(() => {
    if (fromDate === '' && toDate === '') {
      shopdetails();
    }
  }, [fromDate, toDate]);
  const clearfilter = async () => {
    setFromDate('');
    setToDate('');
   
  }

const filteredData = data?.filter(item =>
  item.mainordersid.toString().includes(searchText.toLowerCase()) ||
  item.ename.toLowerCase().includes(searchText.toLowerCase()) ||
  item.shop_name.toLowerCase().includes(searchText.toLowerCase()) ||
  item.final_amount.toString().includes(searchText.toLowerCase())
);

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(amount);
};

  return (

    <div id="appCapsule">
      <div className="section mt-4">
        <div className="section-heading">
          <h2 className="title">Bill List</h2>


        </div>
        <div className="transactions">
        <div className="filter-section mb-3">
  <div className="form-group">
    <label>From Date</label>
    <input
      type="date"
      className="form-control"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>
  <div className="form-group mt-2">
    <label>To Date</label>
    <input
      type="date"
      className="form-control"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>
  <button
    className="btn btn-primary mt-3"
    onClick={shopdetails}
    disabled={!fromDate || !toDate}
  >
    Filter
  </button>
  <button
    className="btn btn-danger mt-3"
    onClick={clearfilter}
    
  >
    Clear
  </button>
</div>

<input
  type="text"
  className="form-control mb-2"
  placeholder="Search by ID, Name, Shop or Amount"
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
/>


{filteredData?.map((item) => (


            <Link to={`/Billdetails?id=${item.mainordersid}`} className="item">

              <div className="detail">

                <img
                  src={invoice_img}
                  alt="img"
                  className="image-block imaged w48"
                />

                <div>
                  <strong><h3>#{item.mainordersid}</h3></strong>
                  <strong>{item.shop_name_tamil} / {item.name}</strong>
                 
                  <b>{FormatDate(item.created_at)}</b>
                  <p style={{ color: 'red', fontSize: 17, marginTop: '2%' }}>
  {formatCurrency(item.final_amount)}
</p>
                </div>
              </div>
              <div className="right">
                <div className="price text-danger">
                </div>
              </div>
            </Link>

          ))}



        </div>
      </div>


      <Footer />
      <Sidebar />




    </div>
  )
}

export default Index